module.exports = __webpack_public_path__ + "static/media/accordian_up_arrow.e94c1e45.svg";